import React from "react";
import {connect} from "react-redux";
import { Switch, Route } from "react-router-dom";


import Form from 'views/Users/Form'
import List from 'views/Users/List'


class Users extends React.Component {
  render() {
    const {match}=this.props;
    return (

          <Switch>
            <Route path={`${match.path}/add`} component={Form}/>
            <Route path={`${match.path}/:id`} component={Form}/>
            <Route component={List}/>
          </Switch>

    );
  }
}
const state=(state)=>({})
const dispatch=(dispatch)=>({})
export default connect(state,dispatch)(Users);



// WEBPACK FOOTER //
// ./src/views/Users/Users.jsx